'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var creatEvent = function (e) {
        var t = {};
        for (var n in e)
            'function' != typeof e[n] && (t[n] = e[n]);
        if (t.originalEvent = e, t.target = e.srcElement || e.target, t.relatedTarget = e.relatedTarget || (e.fromElement === t.target ? e.toElement : e.fromElement), t.keyCode = e.keyCode || e.which, t.which = t.keyCode, t.which || void 0 === e.button || (t.which = 1 & e.button ? 1 : 2 & e.button ? 3 : 4 & e.button ? 2 : 0), /^(?:mouse|contextmenu)|click/.test(e.type)) {
            var o = document.documentElement, r = document.body;
            t.pageX = e.pageX || e.clientX + (o && o.scrollLeft || r && r.scrollLeft || 0) - (o && o.clientLeft || r && r.clientLeft || 0), t.pageY = e.pageY || e.clientY + (o && o.scrollTop || r && r.scrollTop || 0) - (o && o.clientTop || r && r.clientTop || 0);
        }
        return t.stopPropagation = function () {
            e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0;
        }, t.preventDefault = function () {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
        }, t;
    }, addEventListener = function (t, e, n) {
        if (t.addEventListener)
            return t.addEventListener(e, n, !1), function () {
                return t.removeEventListener(e, n);
            };
        if (t.attachEvent) {
            var o = function () {
                var e = creatEvent(window.event);
                return n.bind(t)(e);
            };
            return t.attachEvent('on'.concat(e), o), function () {
                return t.detachEvent('on'.concat(e), o);
            };
        }
        console.error('elm 只能是 domElement 对象');
    }, _default = addEventListener;
exports.default = _default;